
import { api } from 'shared/api';
import { downloadFile } from 'shared/libs/helpers/downloadFile';

export const transactionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTransactionPdf: build.query<
      Blob,
      {
        accountId: number | string;
        transactionId: number | string;
        language?: string;
      }
    >({
      query: ({ accountId, transactionId, language = 'EN' }) => ({
        url: `/private/river/${accountId}/transaction/${transactionId}/pdf?language=${language}`,
        method: 'GET',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
});

export const { useLazyGetTransactionPdfQuery } = transactionsApi;

export const downloadTransactionPdf = (
  trigger: ReturnType<typeof useLazyGetTransactionPdfQuery>[0],
  params: {
    accountId: number | string;
    transactionId: number | string;
    language?: string;
  }
) =>
  downloadFile(trigger, params, (p) => `transaction-${p.transactionId}.pdf`);
